const RAC_LINK = 'https://docs.netmaker.io/pro/rac.html';
const WIREGUARD_LINK = 'https://docs.netmaker.io/integrating-non-native-devices.html';
const PRO_UPGRADE_DOCS_LINK = 'https://docs.netmaker.io/pro/pro-setup.html';
const RAC_DOWNLOAD_DOCS_LINK = 'https://docs.netmaker.io/pro/rac.html#download-installation';
const CORE_DNS_SETUP_LINK = 'https://docs.netmaker.io/architecture.html#components__coredns';
const NFTABLES_DOCS_LINK = 'https://www.linode.com/docs/guides/how-to-use-nftables/';
const IPTABLES_DOCS_LINK = 'https://ioflood.com/blog/install-iptables-command-linux/';
const INTEGRATING_NON_NATIVE_DEVICES_LINK =
  'https://docs.netmaker.io/integrating-non-native-devices.html#integrating-non-native-devices--page-root';
const ROUTE_LOCAL_NETWORK_TRAFFIC_LINK = 'https://docs.netmaker.io/'; /// NEED TO ADD LINK
const HOW_TO_ADD_USERS_TO_NETWORK = 'https://www.netmaker.io/resources/how-to-add-users-to-netmaker-saas';
const USER_MGMT_DOCS_URL = 'https://docs.netmaker.io/#';

const EGRESS_IMG = '/egress.webp';
const RAG_IMG = '/rag.webp';
const NET_IMG = '/network.webp';

export const ExternalLinks = {
  RAC_LINK,
  WIREGUARD_LINK,
  PRO_UPGRADE_DOCS_LINK,
  RAC_DOWNLOAD_DOCS_LINK,
  CORE_DNS_SETUP_LINK,
  NFTABLES_DOCS_LINK,
  IPTABLES_DOCS_LINK,
  INTEGRATING_NON_NATIVE_DEVICES_LINK,
  ROUTE_LOCAL_NETWORK_TRAFFIC_LINK,
  HOW_TO_ADD_USERS_TO_NETWORK,
  USER_MGMT_DOCS_URL,
};

export const AppImages = {
  EGRESS_IMG,
  RAG_IMG,
  NET_IMG,
};
